import { connect } from 'react-redux';
import Courses from './courses';

import { onLoadCourses, onLoadCourse, onExportContent, pinOrUnpinContentAction } from '../../reducers/course.reducers';
import { navigate } from '../../reducers/navigator.reducers';

const mapStateToProps = state => ({
  isLoading: state.courses.isLoading,
  groups: state.courses.courses,
  bulletinBoard: state.courses.bulletinBoard,
});

const mapDispatchToProps = dispatch => ({
  loadCourse: course => dispatch(onLoadCourse(course)),
  navigate: route => dispatch(navigate({ route })),
  onExportContent: url => dispatch(onExportContent(url)),
  pinOrUnpinContent: (bulletinBoardId, pinningDto) => dispatch(pinOrUnpinContentAction({ bulletinBoardId, pinningDto })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Courses);



// WEBPACK FOOTER //
// ./src/app/main/courses/courses.container.js